export function switchDetailViewFn({ modelAction }) {
  let fn;

  switch (modelAction) {
    case "export":
      fn = "getModel";
      break;
    case "delete":
      fn = "deleteModel";
      break;
  }

  return fn;
}

export async function setDetailViewFormData(formData, { model }) {
  return formData;
}
